import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ContentPasteSearchOutlinedIcon from '@mui/icons-material/ContentPasteSearchOutlined';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import DashboardComponent from '../components/DashboardComponent';
import EuroIcon from '@mui/icons-material/Euro';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { useAuthContext } from '../context/AuthContext';
import DomainVerificationIcon from '@mui/icons-material/DomainVerification';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import ListAltIcon from '@mui/icons-material/ListAlt';

const Dashboard = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const { loading, setLoading } = useAuthContext();
  const getCountActiveSigners = async () => {
    try {
      setLoading(true);
      const responseCountActiveSigners = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/TotalCountActiveSigners`,
        { withCredentials: true },
      );
      return responseCountActiveSigners.data.countActiveSigners;
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [countActiveSigners] = await Promise.all([
          getCountActiveSigners(),
        ]);

        let dynamicItems = [];
        if (process.env.REACT_APP_IS_CHAMBER==='TRUE'){
          dynamicItems = [
            {
              title: 'Αναζήτηση Χρηματικών Καταλόγων Πρωτέα',
              paragraph:
                      'Προβόλη Κατάστασης Χρηματικών Καταλόγων που έχουν δημιουργηθεί στον Πρωτέα',
              icon: <ListAltIcon sx={{ fontSize: '6rem' }} />,
              handleButtonClick: () => {
                navigate('/syncMoneyListsProteys');
              },
            },
            {
              title: 'Αναζήτηση και Βεβαίωση Απλήρωτων Οφειλών',
              paragraph:
                      'Αναζήτηση Οφειλών ανα Έτος και Επιμελητήριο και Αποστολη για Βεβαίωση',
              icon: <ContentPasteSearchOutlinedIcon sx={{ fontSize: '6rem' }} />,
              handleButtonClick: () => {
                navigate('/searchUnpaid');
              },
            },
          ];
        } else if (process.env.REACT_APP_IS_CHAMBER==='FALSE'){
          dynamicItems = [
            {
              title: 'Εισαγωγή οφειλών προς Βεβαίωση',
              paragraph:
                      'Εισαγωγή στοιχείων οφειλής και οφειλέτη',
              icon: <ListAltIcon sx={{ fontSize: '6rem' }} />,
              handleButtonClick: () => {
                navigate('/debtEntry');
              },
            },
            {
              title: 'Αναζήτηση και Βεβαίωση Απλήρωτων Οφειλών',
              paragraph:
                      'Αναζήτηση Οφειλών και Αποστολη για Βεβαίωση',
              icon: <ContentPasteSearchOutlinedIcon sx={{ fontSize: '6rem' }} />,
              handleButtonClick: () => {
                navigate('/searchManualDebts');
              },
            },
          ];
        }

        const staticItems = [
          {
            title: 'Αναζήτηση Βεβαιωμένων Οφειλών',
            paragraph: 'Επισκόπηση Βεβαιώσεων Οφειλών προς την ΑΑΔΕ.',
            icon: <ManageSearchIcon sx={{ fontSize: '6rem' }} />,
            handleButtonClick: () => {
              navigate('/deptCertificatesToAade');
            },
          },
          {
            title: 'Προβολή Χρηματικών Καταλόγων',
            paragraph: 'Επισκόπηση Χρηματικών Καταλόγων.',
            icon: <EuroIcon sx={{ fontSize: '6rem' }} />,
            handleButtonClick: () => {
              navigate('/moneyCatalog');
            },
          },
          {
            title: 'Προβολή και Δήλωση Υπογράφοντων',
            paragraph: 'Επισκόπηση Λεπτομερειών και Δήλωση Υπογράφοντων.',
            icon: <EditNoteIcon sx={{ fontSize: '6rem' }} />,
            count: countActiveSigners !== 0
              ? countActiveSigners
              : undefined,
            handleButtonClick: () => {
              navigate('/tableActiveSigners', {
                state: { countActiveSigners: countActiveSigners },
              });
            },
          },
          {
            title: 'Αναζήτηση και Αποβεβαίωση Οφειλών',
            paragraph:
                'Επισκόπηση και Αναζήτηση σχετικά με την Αποβεβαίωση Οφειλών.',
            icon: <DomainVerificationIcon sx={{ fontSize: '6rem' }} />,
            handleButtonClick: () => {
              navigate('/searchVerificationDebts');
            },
          },
          {
            title: 'Επισκόπηση Εισπράξεων',
            paragraph:
                'Επισκόπηση και Αναζήτηση σχετικά με την Είσπραξη των Οφειλών.',
            icon: <LocalAtmIcon sx={{ fontSize: '6rem' }} />,
            handleButtonClick: () => {
              navigate('/payments');
            },
          },
        ];

        setData([...dynamicItems, ...staticItems]);

      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  return (
    <Box
      display={'flex'}
      flexDirection={'row'}
      justifyContent={'flex-start'}
      flexWrap={'wrap'}
      align-items={'flex-start'}
      gap={'16px'}
      sx={{
        justifyContent: 'space-around',
        paddingBottom: '50px',
      }}
    >
      {data?.map((record, index) => {
        return (
          <DashboardComponent
            key={index}
            disabled={loading}
            title={record.title}
            paragraph={record.paragraph}
            icon={record.icon}
            handleButtonClick={record.handleButtonClick}
            count={record.count}
          />
        );
      })}
    </Box>
  );
};

export default Dashboard;
